import { useEffect, useState, useRef } from 'react';
import get from 'lodash.get';

export const useSelectedSku = ({ defaultSkuId, privateOffer, skus, isMultiSku }) => {
    const [initialSkuId, setInitialSkuId] = useState();
    const [selectedSkuId, setSelectedSkuId] = useState(defaultSkuId);
    const privateOfferId = privateOffer && privateOffer.skuId ? privateOffer.skuId : null;
    const skusRef = useRef(skus);

    useEffect(() => {
        // get sku id from url hash when component mounts
        const hash = window.location.hash || '';
        const skuId = get(hash.match(/skuId=(\w+)/), '1');
        if (isMultiSku && skuId && skusRef.current.find(sku => sku.serviceId === skuId)) {
            setInitialSkuId(skuId);
        }
    }, [isMultiSku]);

    useEffect(() => {
        if (initialSkuId) {
            setSelectedSkuId(initialSkuId);
        } else if (privateOfferId) {
            setSelectedSkuId(privateOfferId);
        }
    }, [initialSkuId, privateOfferId]);

    useEffect(() => {
        if (isMultiSku) {
            // update hash when sku changes
            window.history.replaceState(
                null,
                null,
                `${window.location.pathname}#skuId=${selectedSkuId}`
            );
        }
    }, [selectedSkuId, isMultiSku]);

    return [selectedSkuId, setSelectedSkuId];
};
